import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Button } from "reactstrap";
import axios from "axios";
import moment from "moment";
import { UserConsumer } from "../../UserContext";
import { myOfficeHoursAPIs } from "./myOfficeHoursAPIs";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
	timeCol,
	officeHoursTableStyle,
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../ticketModule/variables/ListingVariables";
import { AlertPopups } from "../../components/AlertPopups";
import { MyOfficeTable } from "./MyOfficeTable";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import homeIcon from "../../images/icons/homeIcon.png";
import officeIcon from "../../images/icons/officeIcon.png";
import { APIDateFormat } from "../Dashboard/DashboardVariables";
import ButtonLoader from "../../components/ButtonLoader";

const HoursTable = (props) => {
	let token = null;
	const {
		pageNum,
		setPageNum,
		tableData,
		setTableData,
		numberOfItemsPerPage,
		setNumberOfItemsPerPage,
	} = props;
	const { checkedOutAt } = tableData;
	const [checkOutval, setCheckOutVal] = useState(false);
	const [missingCheckOutList, setmissingCheckOutList] = useState(null);
	const [updateFlag, setUpdateFlag] = useState(null);
	const [checkOutHour, setCheckHour] = useState(null);
	const [checkOutMin, setCheckMin] = useState(null);
	const [checkOutAMPM, setCheckOutAMPM] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [showBtnLoading, setShowBtnLoading] = useState(false);

	const getTime = (cell, row) => {
		const { checkedInAt, checkedOutAt, id, status, flag } = row;
		return flag && checkedInAt ? (
			<>
				<Button
					onClick={(time) => handleSubmit(id, checkedOutAt)}
					className="time-update-btn"
				>
					Update
				</Button>
				<Button
					className="time-reset-btn"
					onClick={() => handleReset(id)}
				>
					reset
				</Button>
			</>
		) : (
			status
		);
	};

	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios({
			url: `${myOfficeHoursAPIs.GetExportToExcelAPI}?Status=${
				props.workStatus ? props.workStatus : 0
			}&WorkStation=${props.workStation}&StartDate=${
				props.startDate
					? moment(props.startDate).format(APIDateFormat)
					: ""
			}&	=${
				props.endDate ? moment(props.endDate).format(APIDateFormat) : ""
			}`,
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "EmployeeCheckinCheckout.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Select Date",
					});
				}
				setShowBtnLoading(false);
			});
	};
	const handleSubmit = (id, index) => {
		if (!checkOutval) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter CheckOut Time",
			});
		} else {
			let date = new Date(missingCheckOutList[index].checkedInAt);
			let t = checkOutval.substring(0, 5);
			let xm = checkOutval.slice(-2);
			let check = t + " " + xm.toUpperCase();
			let options = {
				hour: "numeric",
				minute: "numeric",
				hour12: true,
			};
			let timeString = date.toLocaleString("en-US", options);
			if (
				moment(check, "h:m:s A").format("HH:mm:ss") <
				moment(timeString, "h:m:s A").format("HH:mm:ss")
			) {
				AlertPopups.ErrorAlert.fire({
					text: "CheckOut Time cannot be lower than CheckIn Time",
				});

				setUpdateFlag(null);
			} else {
				let checkOut = checkOutval;
				const body = {
					id: id,
					checkOutTime: checkOut,
				};

				if (body.id === id)
					axios
						.put(
							`${myOfficeHoursAPIs.GetUpdateCheckOutTimeAPI}`,
							body,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then(({ status }) => {
							if (status === 200) {
								AlertPopups.successAlert.fire({
									text: "CheckOut Time Update",
								});
							}
							setUpdateFlag(null);
							getUpdatedHours(index);
						})
						.catch((err) => {
							if (err.response) {
								setUpdateFlag(null);
								AlertPopups.ErrorAlert.fire({
									text: `${err.response.data.message}`,
								});
							}
						});
			}
		}
	};
	const getUpdatedHours = (index) => {
		setIsLoading(true);

		let apiURL = "";
		if (!props.startDate && !props.endDate) {
			apiURL = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&WorkStation=${props.workStation}&Status=${props.workStatus}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		} else {
			apiURL = `${
				myOfficeHoursAPIs.GetMyOfficeHoursAPI
			}?StartDate=${moment(props.startDate).format(
				APIDateFormat
			)}&EndDate=${moment(props.endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&WorkStation=${
				props.workStation
			}&Status=${props.workStatus}&PageNumber=${pageNum}&SortBy=${
				sortBy.dataField
			}_${sortBy.order}`;
		}
		axios
			.get(apiURL, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				if (res.status === 200) {
					props.setPagerData(JSON.parse(res.headers["x-pagination"]));
					setTableData([
						...res.data["missingCheckOuts"],
						...res.data["myOfficeHours"],
					]);
					setmissingCheckOutList(res.data["missingCheckOuts"]);

					setIsLoading(false);
					setCheckHour({
						...checkOutHour,
						[index]: null,
					});

					setCheckMin({
						...checkOutMin,
						[index]: null,
					});

					setCheckOutAMPM({
						...checkOutAMPM,
						[index]: { value: 0, label: "AM" },
					});
				}
			});
	};
	const handleReset = (index) => {
		setUpdateFlag(index);
	};

	const defaultSorted = [
		{
			dataField: "recordDate",
			order: "desc",
		},
	];
	const columns = [
		{
			dataField: "recordDate",
			text: "Record Date",
			sort: true,
			formatter: (recordData) => {
				return moment(recordData).format("DD/MM/YYYY");
			},
		},
		{
			dataField: "checkedInAt",
			text: "Checkin Time",
			sort: false,
			formatter: (cell, row) => {
				const { checkedInAt, checkedInFromOffice } = row;
				return checkedInAt ? (
					checkedInFromOffice != null ? (
						checkedInFromOffice ? (
							<>
								{moment(checkedInAt).format("HH:mm")}
								<Image
									src={officeIcon}
									className="officeIcon"
									alt="office"
									title="Checkin from Office"
								/>
							</>
						) : (
							<>
								{moment(checkedInAt).format("HH:mm")}
								<Image
									src={homeIcon}
									className="homeIcon"
									alt="home"
									title="Checkin from Home"
								/>
							</>
						)
					) : (
						moment(checkedInAt).format("HH:mm")
					)
				) : null;
			},
		},
		{
			dataField: "checkedOutAt",
			text: "Checkout Time",
			sort: false,
			formatter: (cell, row, index, extraData) => {
				const {
					id,
					checkedInAt,
					checkedOutAt,
					recordDate,
					checkoutOutFromOffice,
				} = row;

				return checkedOutAt === null && checkedInAt ? (
					<>
						<div className="d-flex">
							<div className="ml-0 testTimesheet"></div>
							<>
								<div>
									{updateFlag === index &&
									checkOutval != "" ? (
										<div className="d-flex">
											<div className="ml-1">
												{checkOutval}
											</div>
											<Button
												onClick={() =>
													handleSubmit(id, index)
												}
												className="submitUpdateTime-btn ml-1"
											>
												Update
											</Button>
											<Button
												className="resetUpdateTime ml-1"
												onClick={() => {
													setUpdateFlag(null);
												}}
											>
												Reset
											</Button>
										</div>
									) : (
										<div className="col col-9 pl-0 ml-0">
											<TimePicker
												id={`checkOutTime` + index}
												showSecond={false}
												placeholder="00:00 AM/PM"
												onClose={(value, event) => {
													setUpdateFlag(index);
													handleCheckOutChange(
														id,
														index
													);
												}}
												format="h:mm a"
												use12Hours
												disabled={
													moment(recordDate).format(
														APIDateFormat
													) ===
													moment(new Date()).format(
														APIDateFormat
													)
												}
											/>
										</div>
									)}
								</div>
							</>
						</div>
					</>
				) : checkedInAt ? (
					checkoutOutFromOffice != null ? (
						checkoutOutFromOffice ? (
							<>
								{moment(checkedOutAt).format("HH:mm")}
								<Image
									src={officeIcon}
									className="officeIcon"
									alt="office"
									title="Checkout from Office"
								/>
							</>
						) : (
							<>
								{moment(checkedOutAt).format("HH:mm")}
								<Image
									src={homeIcon}
									className="homeIcon"
									alt="home"
									title="Checkout from Home"
								/>
							</>
						)
					) : (
						moment(checkedOutAt).format("HH:mm")
					)
				) : null;
			},
			formatExtraData: missingCheckOutList,
		},
		{
			dataField: "recordDay",
			text: "Record Day",
			sort: true,
		},
		{
			dataField: "workDuration",
			text: "Work Duration",
			sort: true,
			formatter: timeCol,
		},
		{
			dataField: "workStation",
			text: "Work Station",
			sort: true,
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			formatter: getTime,
			style: (status) => {
				return status === "CheckOut Missing"
					? { color: "red" }
					: status === "Present"
					? { color: "rgb(67, 163, 165)" }
					: status === "Late Coming"
					? { color: "red" }
					: { color: "rgb(67, 163, 165)" };
			},
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);

	const handleCheckOutChange = (id, index) => {
		let time = document.getElementById("checkOutTime" + index).value;
		setCheckOutVal(time);
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					myOfficeHoursAPIs.GetMyOfficeHoursAPI
				}?PageSize=${PageSize}&PageNumber=${1}&Status=${
					props.workStatus
				}&WorkStation=${props.workStation}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}${
					props.startDate
						? "&StartDate=" +
						  moment(props.startDate).format(APIDateFormat)
						: ""
				}${
					props.endDate
						? "&EndDate=" +
						  moment(props.endDate).format(APIDateFormat)
						: ""
				}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setTableData([
						...res.data["missingCheckOuts"],
						...res.data["myOfficeHours"],
					]);
					setmissingCheckOutList(res.data["missingCheckOuts"]);

					setIsLoading(false);
					const length = res.data["missingCheckOuts"].length;
					for (let i = 0; i < length; i++) setCheckOutAMPM([i]);
					props.setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			if (!props.startDate && !props.endDate) {
				apiURL = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${props.workStatus}&SortBy=${sortField}_${sortOrder}`;
			} else {
				apiURL = `${
					myOfficeHoursAPIs.GetMyOfficeHoursAPI
				}?StartDate=${moment(props.startDate).format(
					APIDateFormat
				)}&EndDate=${moment(props.endDate).format(
					APIDateFormat
				)}&PageSize=${numberOfItemsPerPage}&WorkStation=${
					props.workStation
				}&Status=${
					props.workStatus
				}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}`;
			}
			props.setSortBy({ dataField: sortField, order: sortOrder });
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?${
				props.startDate
					? "StartDate=" +
					  moment(props.startDate).format(APIDateFormat)
					: ""
			}${
				props.endDate
					? "&EndDate=" + moment(props.endDate).format(APIDateFormat)
					: ""
			}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&WorkStation=${
				props.workStation
			}&Status=${props.workStatus}`;
			getData = true;
		}
		if (getData) {
			setIsLoading(true);
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setPageNum(page);
						props.setPagerData(
							JSON.parse(res.headers["x-pagination"])
						);
						setTableData([
							...res.data["missingCheckOuts"],
							...res.data["myOfficeHours"],
						]);
						setmissingCheckOutList(res.data["missingCheckOuts"]);
						setIsLoading(false);
					}
				});
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<Container fluid className="p-0">
						<Row className=" mb-1 align-items-center">
							<Col xl={10} lg={10}>
								<div className="excluded-hours">
									*Lunch hours are excluded
								</div>
								<div className="excluded-hours mt-0">
									*Missing checkout will always be on top
								</div>
							</Col>

							<Col className="align-items-center d-flex btns-col">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									disabled={
										tableData?.length ===
											missingCheckOutList?.length ||
										showBtnLoading
									}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={showBtnLoading}
								/>
							</Col>
						</Row>
						<PaginationProvider
							pagination={paginationFactory({
								custom: true,
								totalSize: props.pagerData
									? props.pagerData.TotalCount
									: 0,
								page: pageNum,
								sizePerPage: numberOfItemsPerPage,
								paginationSize: numberOfItemsPerPage,
							})}
						>
							{({ paginationProps, paginationTableProps }) => {
								return (
									<MyOfficeTable
										keyField={`${"id"}_${"checkedOutAt"}`}
										columns={columns}
										items={tableData}
										tableStyle={officeHoursTableStyle}
										paginationProps={paginationProps}
										paginationTableProps={
											paginationTableProps
										}
										tableLoader={isLoading}
										loading={isLoading}
										defaultSorted={defaultSorted}
										bodyClasses={
											checkedOutAt ? "hours-trow" : null
										}
										pagerData={props.pagerData}
										onTablePageChange={handleTableChange}
										SearchBar={() => {
											return null;
										}}
										receiveData={(PageSize) => {
											receiveData(PageSize);
										}}
									/>
								);
							}}
						</PaginationProvider>
					</Container>
				);
			}}
		</UserConsumer>
	);
};

export default HoursTable;
